import { LocationWithImages } from "~/lib/server-functions/get-locations";

/**
 * Type for location capacity fields - allows partial objects
 */
type LocationCapacityFields = {
  capacityStanding?: number | null;
  capacitySeated?: number | null;
  seatingBanquet?: number | null;
  seatingBlock?: number | null;
  seatingParliamentary?: number | null;
  seatingRow?: number | null;
  seatingTable?: number | null;
  seatingUShape?: number | null;
  seatingStanding?: number | null;
  maxCapacity?: number | null;
};

/**
 * Helper to get maximum capacity from all capacity and seating fields
 * Works with full LocationWithImages or partial objects with capacity fields
 */
export const getMaxCapacity = (
  location: LocationWithImages | LocationCapacityFields,
): number | null => {
  if (location.maxCapacity != null && location.maxCapacity > 0) {
    return location.maxCapacity;
  }

  if (location.capacityStanding != null && location.capacityStanding > 0) {
    return location.capacityStanding;
  }

  if (location.seatingStanding != null && location.seatingStanding > 0) {
    return location.seatingStanding;
  }

  return null;
};
